// Enum
const EstrategiaApuracaoEnum: { [key: string]: any } = Object.freeze({
  ARGUMENTO_NORMALIZADO: {
    descricao: 'label.argumento_normalizado',
    key: 'ARGUMENTO_NORMALIZADO',
  },
  MEDIA_PONDERADA: {
    descricao: 'label.media_ponderada',
    key: 'MEDIA_PONDERADA',
  },
  SOMA_PONDERADA_NORMALIZADA: {
    descricao: 'label.soma_ponderada_normalizada',
    key: 'SOMA_PONDERADA_NORMALIZADA',
  },
  SOMA_PONDERADA_NORMALIZADA_GRUPOS: {
    descricao: 'label.soma_ponderada_normalizada_grupos',
    key: 'SOMA_PONDERADA_NORMALIZADA_GRUPOS',
  },
  SOMA_PONDERADA_NORMALIZADA_TOTAL: {
    descricao: 'label.soma_ponderada_normalizada_total',
    key: 'SOMA_PONDERADA_NORMALIZADA_TOTAL',
  },
  TOTAL_ABSOLUTO_VOTOS: {
    descricao: 'label.total_absoluto_votos',
    key: 'TOTAL_ABSOLUTO_VOTOS',
  },
  getAll: () =>
    Object.keys(EstrategiaApuracaoEnum)
      .filter((genericProperty) => typeof EstrategiaApuracaoEnum[genericProperty] === 'object')
      .map((indexFound) => EstrategiaApuracaoEnum[indexFound]),
});

// Exports

export default EstrategiaApuracaoEnum;
